import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {EquipmentEnums} from '@namespaces/equipment.namespace';
import {SelectValueInterface} from '@interfaces/select-value.interface';

export type ElementTypeSelectValue = SelectValueInterface<EquipmentEnums.Type>;

@Injectable()
export class EquipmentTypesProvider {
    public data$ = new BehaviorSubject<ElementTypeSelectValue[]>([
        {id: EquipmentEnums.Type.general,       title: 'Основное'},
        {id: EquipmentEnums.Type.reference,     title: 'Образец (эталон)'},
        {id: EquipmentEnums.Type.material,      title: 'Материал'},
        {id: EquipmentEnums.Type.dosimetric,    title: 'Дозиметрическое оборудование'},
        {id: EquipmentEnums.Type.device,        title: 'Датчик/приспособление'},
        {id: EquipmentEnums.Type.help,          title: 'Вспомогательное'}
    ]);
}

